module.exports = __webpack_public_path__ + "media/fonts/ArchivoNarrow-Regular-7377ccb9.ttf";